import React from 'react';

import Sankey, {
  Tooltip,
  Link,
  Node
} from 'devextreme-react/sankey';

// import data from '../../data/SK.json';
import SmallValuesGrouping from "devextreme-react/pie-chart";
import { SubAccount, ClientsAPI } from 'src/api'
type Props = {
  client?: SubAccount
}
class SankeyPages extends React.Component<Props> {
  state = {
    data: undefined,
    narrative: undefined
  }
  fetchData = (client: SubAccount) => {
    // const params = {
    //   narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
    //   report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
    //   sub_account_id: client.id,
    //   period_index: "1449",
    //   period_type: "monthly"
    // }

    ClientsAPI.getReportData(client, 'demographics_sankey.json').then(result => {
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    // ClientsAPI.getNarrative(client, params).then(result => {
    //   // console.log('done', result)
    //   this.setState({ narrative: result[0] });
    // }).catch(error => {
    //   // console.log('error', error)
    // })
  }
  render() {
    const { data, narrative } = this.state
    const { client } = this.props;
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (<>
      <Sankey id="sankey"
        dataSource={data}
        sourceField="source"
        targetField="target"
        weightField="weight"
        title="Channel-Source-LandingPage Flow"
      >
        <SmallValuesGrouping />
        <Tooltip
          enabled={true}
          customizeLinkTooltip={customizeLinkTooltip}
        >
        </Tooltip>

        <Link
          colorMode="gradient">
        </Link>
        <Node
          width={8}
          padding={30}>
        </Node>

      </Sankey>
      </>
    );
  }
}

function customizeLinkTooltip(info: { source: any; target: any; weight: any; }) {
  return {
    html: `<b>From:</b> ${info.source}<br/><b>To:</b> ${info.target}<br/><b>Weight:</b> ${info.weight}`
  };
}

export default SankeyPages;



// WEBPACK FOOTER //
// ./src/components/ReportComponents/SankeyPages.tsx